import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue';
import { useStore } from 'vuex';
import { ElNotification } from 'element-plus';
import { useI18n } from 'vue-i18n';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  setup(__props) {

const { track } = useTrack();
const store = useStore();
const searchInput = ref('');

const { t } = useI18n();

let bbox;

const handleSearch = () => {
  if (!bbox) {
    if (searchInput.value && searchInput.value.split(/[,，]/).length == 2) {
      ElNotification({
        title: t('Search.LonLatError.title'),
        message: t('Search.LonLatError.message'),
        type: 'error',
      });
    }
    return;
  }
  store.state.engineStore.engine?.setBBox(bbox);
  store.state.engineStore.engine?.showCenterMarker(bbox);
};
const handleClear = () => {
  searchInput.value = '';
  bbox = undefined;
  store.state.engineStore.engine?.hideCenterMarker();
};
const handleSelect = (item) => {
  bbox = item.bbox;
};
const fetchSuggestions = async (queryString, callback) => {
  if (!queryString) {
    callback([]);
    return;
  }
  const coordinate = queryString.split(/[,，]/);
  if (coordinate.length == 2) {
    const lat = parseFloat(coordinate[1]);
    const lng = parseFloat(coordinate[0]);
    if (lng >= -180 && lng <= 180 && lat >= -90 && lat <= 90) {
      bbox = [lng - 0.1, lat - 0.1, lng + 0.1, lat + 0.1];
    }
    callback([]);
    return;
  }

  try {
    const response = await fetch(
      `https://api.cesium.com/v1/geocode/autocomplete?text=${queryString}&access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4OGQwZTM2MC00NjkzLTRkZTgtYTU5MS0xZTA1NTljYWQyN2UiLCJpZCI6NTUwODUsImlhdCI6MTYyMDM5NjQ3NH0.lu_JBwyngYucPsvbCZt-xzmzgfwEKwcRXiYs5uV8uTM`,
    );
    const data = await response.json();

    const formattedData = data.features.map((item) => ({
      value: item.properties.label,
      bbox: item.bbox,
    }));

    callback(formattedData);

    track(
      FunctionIdEnum.globalLayer_earth_searchLocation,
      EventTypeEnum.SEARCH,
      {
        keyword: queryString,
      },
    );
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_CircleClose = _resolveComponent("CircleClose")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createBlock(_component_el_autocomplete, {
    class: "search-input",
    modelValue: searchInput.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
    debounce: "1000",
    "fetch-suggestions": fetchSuggestions,
    onSelect: handleSelect,
    placeholder: _unref(t)('CesiumViewer.search')
  }, {
    suffix: _withCtx(() => [
      (!!searchInput.value)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            onClick: handleClear,
            style: {"margin-right":"5px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CircleClose, { style: {"cursor":"pointer"} })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_icon, { onClick: handleSearch }, {
        default: _withCtx(() => [
          _createVNode(_component_Search)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "placeholder"]))
}
}

})